import { combineReducers } from 'redux'

import AdminReducer from './admin'
import AdminRoleReducer from './adminRole'
import CancelJobReducer from './cancelledJob'
import CancelRecurringJobReducer from './cancelledRecurringJob'
import ClientReducer from './client'
import CustomerReducer from './customer'
import DashboardReducer from './dashboard'
import EmployeeReducer from './employee'
import EndedBaseJobReducer from './endedBaseJob'
import FeedbackReducer from './feedback'
import FunderReducer from './funder'
import FutureJobReducer from './futureJob'
import GeneralReducer from './general'
import JvpJobRecuder from './jvpJob'
import JvpJobRecurringRecuder from './jvpJobRecurring'
import JvpJobSummaryRecuder from './jvpJobSummary'
import JobReducer from './job'
import PastJobReducer from './pastJob'
import PendingEmployeeJobReducer from './pendingEmployeeJob'
import PendingEmployeeBaseJobReducer from './pendingEmployeeBaseJob'
import RecurringJobReducer from './recurringJob'
import RecurringJobListReducer from './recurringJobList'
import ModuleReducer from './module'
import PayrollFvpReducer from './payrollFvp'
import SettingFileReducer from './setting/file'
import SettingStoreReducer from './setting/store'
import SettingFileModuleReducer from './setting/fileModulePermission'
import UserReducer from './user'

export default combineReducers({
  Admin: AdminReducer,
  AdminRole: AdminRoleReducer,
  CancelledJob: CancelJobReducer,
  CancelledRecurringJob: CancelRecurringJobReducer,
  Client: ClientReducer,
  Customer: CustomerReducer,
  Dashboard: DashboardReducer,
  Employee: EmployeeReducer,
  EndedBaseJob: EndedBaseJobReducer,
  Feedback: FeedbackReducer,
  File: SettingFileReducer,
  FileModule: SettingFileModuleReducer,
  Funder: FunderReducer,
  FutureJob: FutureJobReducer,
  General: GeneralReducer,
  JvpJob: JvpJobRecuder,
  JvpJobRecurring: JvpJobRecurringRecuder,
  JvpJobSummary: JvpJobSummaryRecuder,
  Job: JobReducer,
  PastJob: PastJobReducer,
  PendingEmployeeJob: PendingEmployeeJobReducer,
  PendingEmployeeBaseJob: PendingEmployeeBaseJobReducer,
  Module: ModuleReducer,
  PayrollFvp: PayrollFvpReducer,
  RecurringJob: RecurringJobReducer,
  RecurringJobList: RecurringJobListReducer,
  Store: SettingStoreReducer,
  User: UserReducer
})
